var _path;

import * as React from "react";

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.5V4H9.5C8.669 4 8 4.669 8 5.5v29c0 .831.669 1.5 1.5 1.5h21c.831 0 1.5-.669 1.5-1.5V14h-8.5c-.825 0-1.5-.675-1.5-1.5zm4 14.75c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75v-.5c0-.413.338-.75.75-.75h10.5c.413 0 .75.337.75.75v.5zm0-4c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75v-.5c0-.413.338-.75.75-.75h10.5c.413 0 .75.337.75.75v.5zm0-4.5v.5c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75v-.5c0-.413.338-.75.75-.75h10.5c.413 0 .75.337.75.75zm6-7.131V12h-8V4h.381c.4 0 .782.156 1.063.438l6.119 6.125c.28.28.437.662.437 1.056z"
  })));
}

export default SvgFile;